import { render } from "./OcrReportMapPanel.vue?vue&type=template&id=5112288d"
import script from "./OcrReportMapPanel.vue?vue&type=script&lang=js"
export * from "./OcrReportMapPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__